require ("./style.css")
import React from 'react';
import AcquireWebComponent from '../../framework/MaterialUI'
import BreadCrumb from '../CreateCampaigns/Title/Title'
import { Row, Col, FullRow } from '../../framework/Grid'
import LineGraphicSection from './LineGraphic';
import AggregatedTable from './AggregatedTable';
import Tooltip from 'rc-tooltip';
import TipIcon from 'material-ui/svg-icons/action/info-outline';
import Checkbox from 'material-ui/Checkbox';
import Dialog from 'material-ui/Dialog';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import { pdfReportHeaderDataUri, downLoadCSVFunc, addPdfFooter } from '../../../utils/utility'

import Select from 'react-select';
import moment from "moment-timezone/moment-timezone";

const pdfConverter = require('jspdf')
const html2canvas = require('html2canvas')

const styles={
	tableHeaderStyle: {
		border: 'none',
    background: '#F5F5F5',
    fontSize: '12px',
    fontWeight: "bold"
	},
}

class CampaignReport extends AcquireWebComponent {
	constructor(props) {
		super(props);
		this.state = {
			showDownloadDialog : false,
			onPdfReportDownload: false,
			onCsvReportDownload: false,
			disabledBtnDownload: false
		}
	}

	componentDidMount() {
		const {match} = this.props
		if ( match && match.params) {
			this.props.getCampaignById(match.params.id);
			this.props.setReportDateRange("life-of-campaign");
			this.props.getCampaignGroupAggregated(match.params.id, "life-of-campaign")
			this.props.getCampaignChannelAggregated(match.params.id, "life-of-campaign");
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.client_tz && (nextProps.client_tz !== this.props.client_tz)) {
			moment.tz.setDefault(nextProps.client_tz);
		}
		
		if (nextProps.reportDateRange && (nextProps.reportDateRange !== this.props.reportDateRange)) {
			this.props.getCampaignGroupAggregated(nextProps.match.params.id, nextProps.reportDateRange);
			this.props.getCampaignChannelAggregated(nextProps.match.params.id, nextProps.reportDateRange);
		}

		if ((nextProps.campaignDetail !== this.props.campaignDetail) && nextProps.campaignDetail){
			if (nextProps.campaignDetail.clientId !== this.props.client_id){
				this.props.selectClient(nextProps.campaignDetail.clientId);
			}
		}

    if (nextProps.client_id !== this.props.client_id && (this.props.client_id))  {
			this.props.selectClient(nextProps.client_id);
		}
	}

	dateItem() {
		return (
			[
				{value : "life-of-campaign", label:"Life of Campaign"},
				{value : "yesterday", label:"Yesterday"},
				{value : "today", label:"Today"},
				{value: "last-7-days", label:"Last 7 Days"},
				{value: "last-30-days", label:"Last 30 Days"}
			]
		)
	}

	downloadCsvReport() {
		this.setState({onCsvReportDownload: true, showDownloadDialog: false});
		this.handleCsvDownload();
	}
	
  downloadPdfReport() {
		this.setState({onPdfReportDownload: true, showDownloadDialog: false});
		this.handlePdfDownload();
	}

	isReportWithChannel(data) {
		const emailCount = find(data, {channel:"Email"});
		const socialCount = find(data, {channel:"Social"});
		const displayCount = find(data, {channel:"Display"});
		return (!isEmpty(emailCount)) || (!isEmpty(socialCount)) || (!isEmpty(displayCount));
	}

	handleCsvDownload() {
		const {clients, client_info, campaignDetail, reportDateRange, campaignAggregatedReport, 
			campaignChannelAggregatedReport} = this.props;
		let client_name = client_info.name;
		let bu_name = "";
		if (client_info.parentClientId) {
			const parent_client = find(clients, (c) => {return c.id === client_info.parentClientId })
      if (parent_client) {
        client_name = parent_client.name;
        bu_name = client_info.name;
      }
		}
		const report_sub_title = this.isReportWithChannel(campaignChannelAggregatedReport) ? "_Aggregate_Campaign_Report_WithChannel_" : 
			"_Aggregate_Campaign_Report_";

		let csvFileName = bu_name === "" ? client_name + report_sub_title + campaignDetail.name: 
			bu_name + report_sub_title + campaignDetail.name;

		let title_line = 'AudienceAnywhere Aggregate Campaign Report  ,,,,,,,,\r\n'
		let date_line = "Today's Date," + moment().format("MM/DD/YY") + ",,,,,,,\r\n"
		let client_line = "Client," + client_name + ",,,,,,,\r\n";
		let business_unit_line = isEmpty(bu_name) ? "" : "Business Unit," + bu_name + ",,,,,,,\r\n";
		let date_filter_line = "Date Filter," + this.reportDateFilter(reportDateRange) + ",,,,,,,\r\n";
		const split_line = ",,,,,,,,\r\n";
		const campaign_group_name_line = "Campaign Group Name," + campaignDetail.name + ",,,,,,,\r\n";
		const campaign_group_id_line = "Campaign Group ID," + campaignDetail.campaignId + ",,,,,,,\r\n";
		const client_campaign_id_line = "Client Campaign ID," + campaignDetail.clientCampaignId + ",,,,,,,\r\n";
		const campaign_group_status_line = "Campaign Group Status," + campaignDetail.status + ",,,,,,,\r\n";
		const campaign_group_start_date = "Campaign Group Start Date," + moment(campaignDetail.startDate).format("MM/DD/YY") + 
			",,,,,,,\r\n";
		const campaign_group_end_date = "Campaign Group End Date," + moment(campaignDetail.endDate).format("MM/DD/YY") + 
			",,,,,,,\r\n";

		let aggregate_table_tile_line = ",";
		let aggregate_table_messages_line = "Messages,";
		let aggregate_table_engagement_line = "Engagement,";
		if (campaignAggregatedReport) {
			campaignAggregatedReport.forEach(data => {
				aggregate_table_tile_line += data.time + ",";
				aggregate_table_messages_line += data.messages + ",";
				aggregate_table_engagement_line += data.engagement + ",";
			});
		}
		aggregate_table_tile_line += "\r\n";
		aggregate_table_messages_line += "\r\n";
		aggregate_table_engagement_line += "\r\n";

		let total_activity_line = "Total Activity,";
		let total_messages_line = "Messages,";
		let total_engagement_line= "Engagement,";
		if (campaignChannelAggregatedReport) {
			campaignChannelAggregatedReport.forEach(data => {
				const channel = data.channel.charAt(0).toUpperCase() + data.channel.substr(1); 
				total_activity_line += channel + ",";
				total_messages_line += data.messages + ",";
				total_engagement_line += data.engagement + ",";
			})
		}
		total_activity_line += "\r\n";
		total_messages_line += "\r\n";
		total_engagement_line += "\r\n";

		const messages_definition_line = "Messages: The total number of marketing messages delivered across all channels to the respective audience.,,,,,,,,\r\n";
		//const engagement_definition_line = "Engagement: The number of times a user takes action within the message delivered; e.g. clicks,,,,,,,,\r\n";
		const engagement_definition_line = "Any type of measured activitiy taken by the user against a delivered ad or email. This includes clicks, comments, shares, likes, video views....\r\n";
		let resultString = title_line + date_line + client_line + business_unit_line + date_filter_line + split_line +
			campaign_group_name_line + campaign_group_id_line + client_campaign_id_line + campaign_group_status_line +
			campaign_group_start_date + campaign_group_end_date + split_line + aggregate_table_tile_line + 
			aggregate_table_messages_line + aggregate_table_engagement_line + split_line + total_activity_line +
			total_messages_line + total_engagement_line + split_line + messages_definition_line + engagement_definition_line;

		csvFileName += "_" + this.reportDateFilter(reportDateRange);
		csvFileName = csvFileName.replace(new RegExp(' ', 'g'), '_');
		downLoadCSVFunc(resultString, csvFileName);
		setTimeout(function(){
			this.setState({onCsvReportDownload: false})
		}.bind(this), 2000)
	}

	handlePdfDownload() {
		const {clients, client_info, campaignDetail, campaignChannelAggregatedReport} = this.props;
		let client_name = client_info.name;
		let bu_name = "";
		if (client_info.parentClientId) {
			const parent_client = find(clients, (c) => {return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10)})
      if (parent_client) {
        client_name = parent_client.name;
        bu_name = client_info.name;
      }
		}

		const report_sub_title = this.isReportWithChannel(campaignChannelAggregatedReport) ? "_Aggregate_Campaign_Report_WithChannel_" : 
		"_Aggregate_Campaign_Report_";

		let pdfFileName = bu_name === "" ? client_name + report_sub_title + campaignDetail.name: 
			bu_name + report_sub_title + campaignDetail.name;

		const pdf = new pdfConverter('p', 'mm', 'a4')
		pdf.setFont("Helvetica")
		pdf.setFontType("normal")
		pdf.setFontSize(9)
		const pageWidth = 186

		const el_date_picker = document.getElementsByClassName("date-picker-container")[0];
		const el_campaign_graph = document.getElementsByClassName("campaign-graph-container")[0];
		const el_campaign_summary = document.getElementsByClassName("campaign-summary-container")[0];

		let canvasDatePicker = null;
		let canvasGraph = null;
		let canvasSummary = null;
		let isCanvasDatePickerReady = false;
		let isCanvasGraphReady = false;
		let isCanvasSummaryReady = false;
		const oriWidth = el_campaign_graph.offsetWidth;
		const oriDatePickerWidth = el_date_picker.offsetWidth;
		document.getElementsByClassName("nav-btn-download-report")[0].style.display="none";
		document.getElementsByClassName("definition-container")[0].style.display="block";
		document.getElementsByClassName("tooltip-container")[0].style.display="none";
		const tableLinks = document.getElementsByClassName("agg-title-link");
		let linkColor = null
		if (tableLinks.length > 0) {
			linkColor = tableLinks[0].style.color;
			forEach(tableLinks, (el)=>{
				el.style.color = "#000";
			})
		}

		el_date_picker.style.width = "1024px";
		el_campaign_graph.style.width = "1024px";
		el_campaign_summary.style.width = "1024px";
		setTimeout(function () {
			html2canvas(el_date_picker, {logging:false}).then(function (canvas) {
				canvasDatePicker = canvas
				isCanvasDatePickerReady = true
				el_date_picker.style.width = oriDatePickerWidth + 'px'
			 })
		}, 50);
		setTimeout(function() {
			html2canvas(el_campaign_summary, {logging: false}).then(function (canvas) {
				canvasSummary = canvas;
				isCanvasSummaryReady = true;
				el_campaign_summary.style.width = oriWidth + 'px';
			})
		}, 50);
		setTimeout(function() {
			html2canvas(el_campaign_graph, {logging: false}).then(function (canvas) {
				canvasGraph = canvas;
				isCanvasGraphReady = true;
				el_campaign_graph.style.width = oriWidth + 'px';
			})
		}, 50);

		let top = 34
		const left = 12
		let intervalId = setInterval(function () {
			if (isCanvasDatePickerReady === false || isCanvasSummaryReady === false || isCanvasGraphReady === false) {
				console.log("PDF Generating...")
			} else {
				clearInterval(intervalId);
				setTimeout(function(){
					pdf.setFillColor(127,127,127);
					pdf.rect(0, 15 , 210, 10, 'F');
			
					pdf.setTextColor(0, 0, 0)
					pdf.setFontSize(9)
					pdf.setFontType('bold')
					pdf.addImage(pdfReportHeaderDataUri(), 'PNG', 10.5, 3, 60, 0)
					pdf.text(198, 8, moment().format('MMMM DD, YYYY'), null, null, 'right');
			
					pdf.setTextColor(255, 255, 255)
					pdf.setFontType('bold')
					pdf.text(12, 21, 'Client:')			
					//const lenClientName = getTextSize(client_name.trim(), 'helvetica') 
					pdf.setFontType('normal')
					pdf.text(26, 21, client_name ? client_name.trim() : "")
					//cm to inches
					let start = 90; //46 + lenClientName.width * 0.3937 + 0.4
					if (!isEmpty(bu_name)) {
						pdf.setFontType('bold')
						pdf.text(start, 21, 'Business Unit:')
						start += 26.5
						pdf.setFontType('normal')
						pdf.text(start, 21, bu_name ? bu_name.trim() : '')
					}
					pdf.setTextColor(0, 0, 0)
					//pdf.setLineWidth(0.05)
					//pdf.line(0, 27, 210, 27)
					pdf.text(12, 30, 'Campaigns > ' + campaignDetail.name);

					pdf.addImage(canvasDatePicker.toDataURL(), 'PNG', left, top, pageWidth, 0);
					top += (canvasDatePicker.height * pageWidth / canvasDatePicker.width);
					pdf.addImage(canvasSummary.toDataURL(), 'PNG', left, top, pageWidth, 0);
					top += (canvasSummary.height * pageWidth / canvasSummary.width) + 4;
					pdf.addImage(canvasGraph.toDataURL(), 'PNG', left, top, pageWidth, 0);
					addPdfFooter(pdf)

					document.getElementsByClassName("nav-btn-download-report")[0].style.display="block";
					document.getElementsByClassName("definition-container")[0].style.display="none";
					document.getElementsByClassName("tooltip-container")[0].style.display="block";
					if (tableLinks.length > 0) {
						forEach(tableLinks, (el)=>{
							el.style.color = linkColor;
						})
					}
					pdfFileName = pdfFileName.replace(new RegExp(' ', 'g'), '_') + ".pdf";
					pdf.save(pdfFileName)
					this.setState({onPdfReportDownload: false});
				}.bind(this), 100);
			}
		}.bind(this), 50);
	}
	
	handleDownload(e) {
    e.preventDefault();

    if (this.refs.cbPDF.state.switched) {
      this.downloadPdfReport();
    }

    if (this.refs.cbCSV.state.switched) {
      this.downloadCsvReport();
    }
  }

	reportDateFilter(dayRange) {
		let result = "";
		switch (dayRange) {
			case "yesterday":
				result = "Yesterday"
				break;
			case "today":
				result = "Today"
				break;
			case "last-7-days":
				result = "Last 7 Days";
				break;
			case "last-30-days":
				result = "Last 30 Days";
				break;
			case "life-of-campaign":
			default:
				result = "Life of Campaign";
				break;
		}
		return result;
	}

	cbPDFChange(e, isInputChecked) {
    const result = (!this.refs.cbCSV.state.switched) && (!isInputChecked);
    this.setState({disabledBtnDownload: result});
  }

  cbCSVChange(e, isInputChecked) {
    const result = (!this.refs.cbPDF.state.switched) && (!isInputChecked);
    this.setState({disabledBtnDownload: result});
	}
	
	render(){
		const {campaignDetail, campaignAggregatedReport, campaignChannelAggregatedReport, reportDateRange, 
			setReportDateRange} = this.props;
		const lineData = []
		if (campaignAggregatedReport) {
			campaignAggregatedReport.forEach(data => {
				lineData.push({time: data.time, messages: data.messages, engagement: data.engagement});
			});
		}

		const tableSubTitle = "Date: " + this.reportDateFilter(reportDateRange);
		return (
			<div className="campaign-report-container" style={{background:"#FFFFFF", fontSize:"16px"}}>
        <BreadCrumb
          crumb={campaignDetail ? campaignDetail.name : "Create Campaign"}
          linkName="Campaigns" showDownloadBtn={true}
					handleDownload={()=>{this.setState({showDownloadDialog: true});}}
					selected_client={this.props.client_id}
        />
				<Row className="light-grey-border-top mt-20 no-margin-left no-margin-right no-margin-bottom no-padding-left no-padding-right date-picker-container">
					<Col xs="1" sm="1" md="1" lg="1" className="no-padding-left no-padding-right">
						<strong>Date</strong>
					</Col> 
					<Col xs="3" sm="3" md="3" lg="3" style={{marginLeft:"-50px"}}>
						<Select className="report-date-selector left-10 z-index-199"
              value={reportDateRange}
              clearable={false}
							searchable={false}
							options={this.dateItem()}
							placeholder={"Select Day"}
							onChange={setReportDateRange.bind(this)}
            />
					</Col>
				</Row>
				<FullRow className="light-grey-border no-margin-left no-margin-right no-padding mb-20 campaign-summary-container">
					<h3 className="pl-10" style={{fontSize:'24px', fontWeight:'bold'}}>Campaign Group</h3>
          <table style={{width:"98%", marginLeft:'10px', marginBottom:"20px"}}>
            <thead style={styles.tableHeaderStyle}>
              <tr style={{height:"42px"}}>
								<th style={{width:'16%', paddingLeft:"20px"}}><strong>Campaign Group Name</strong></th>
                <th style={{width:'14%', paddingRight:"10px"}}><strong>Campaign Group ID</strong></th>
                <th style={{width:'14%', paddingRight:"10px"}}><strong>Client Campaign ID</strong></th>
                <th style={{width:'14%', paddingRight:"10px"}}><strong>Campaign Group Status</strong></th>
                <th style={{width:'14%', paddingRight:"10px"}}><strong>Campaign Start Date</strong></th>
                <th style={{width:'14%', paddingRight:"10px"}}><strong>Campaign End Date</strong></th>
							</tr>
						</thead>
						<tbody>
							<tr style={{height: "42px"}}>
								<td style={{width:'16%', paddingLeft:"20px"}}>{campaignDetail && campaignDetail.name}</td>
                <td style={{width:'16%', paddingRight:"10px"}}>{campaignDetail && campaignDetail.campaignId}</td>
                <td style={{width:'14%', paddingRight:"10px"}}>{campaignDetail && campaignDetail.clientCampaignId}</td>
                <td style={{width:'12%', paddingRight:"10px"}}>{campaignDetail && campaignDetail.status}</td>
                <td style={{width:'14%', paddingRight:"10px"}}>{campaignDetail && moment(campaignDetail.startDate).format("MM/DD/YY")}</td>
                <td style={{width:'14%', paddingRight:"10px"}}>{campaignDetail && moment(campaignDetail.endDate).format("MM/DD/YY")}</td>
							</tr>
						</tbody>
					</table>
				</FullRow>
				<FullRow className="light-grey-border no-margin-left no-margin-right no-padding mb-20 pb-20 pr-10 campaign-graph-container">
					<h3 className="pl-10" style={{fontSize:'24px', fontWeight:'bold'}}>Aggregated Results</h3>
					<div style={{position:"absolute", top:'25px', right:'12px'}} className="tooltip-container">
						<Tooltip placement="right"
                  overlayClassName="campaign-report-legend"
                  overlayStyle={{ width: "254px" }}
                  overlay={
                    <div className="legend-overlay-container">
											<strong>Messages - </strong>The total number of <br />
											marketing messages delivered across <br />
											all channels to the respective audience.
											<br /><br />
											<strong>Engagement - </strong>Any type of measured <br /> 
											activity taken by the user against<br />
											a delivered ad or email. <br />
											This includes clicks, comments, <br />
											shares, likes, video views....
                    </div>
                  }
                  arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                >
                  <TipIcon 
                    style={{color: 'black', width: '24px', height: '24px', marginTop: '0px', marginLeft: '0px', cursor: 'pointer'}}
                  />
                </Tooltip>
					</div>
					<LineGraphicSection animation={false} key={'line-section'} title="" data={lineData} subTitle={tableSubTitle} />
					<AggregatedTable data={campaignChannelAggregatedReport} campaignId={this.props.match.params.id} 
						parentCampaignDetail={campaignDetail} />
					<FullRow className="no-margin-bottom no-padding-bottom definition-container" style={{display:"none"}}>
						<h3>DEFINITIONS</h3>
						<div className="mb-10" style={{fontSize:'13px'}}><strong>Messages - </strong>The total number of marketing messages delivered across all channels to the respective audience.</div>
						<div style={{fontSize:'13px'}}><strong>Engagement - </strong>Any type of measured activity taken by the user against a delivered ad or email. This includes clicks, comments, shares, likes, video views....</div>
					</FullRow>
				</FullRow>
				<Dialog open={this.state.onCsvReportDownload} style={{top: '-1.8em'}} modal={true}  contentStyle={{width:"500px"}}
					overlayStyle={{opacity: 0.9, backgroundColor:'#666666'}}>
					<Row className="mt-20">
							<Col offsetXs="1" offsetSm="1" offsetMd="1" offsetLg="1" xs="7" sm="7" md="7" lg="7" className="text-right">
									<div>{ "Downloading, please wait..."}</div>
							</Col>
							<Col xs="1" sm="1" md="1" lg="1">
									<img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
							</Col>
					</Row>
				</Dialog>
				<Dialog open={this.state.onPdfReportDownload} style={{top: '-1.8em'}} modal={true}  contentStyle={{width:"500px"}}
					overlayStyle={{opacity: 0.9, backgroundColor:'#666666'}}>
					<Row className="mt-20">
							<Col offsetXs="1" offsetSm="1" offsetMd="1" offsetLg="1" xs="7" sm="7" md="7" lg="7" className="text-right">
									<div>{ "Downloading, please wait..."}</div>
							</Col>
							<Col xs="1" sm="1" md="1" lg="1">
									<img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
							</Col>
					</Row>
				</Dialog>
				<Dialog open={this.state.showDownloadDialog} style={{top: '-1.8em'}} modal={true} 
          contentStyle={{width:"440px"}}>
            <FullRow className="no-margin-top no-padding" style={{fontSize: '16px', color:"#000"}}>
              <strong>Choose the type of file you would like to download</strong>
            </FullRow>
            <FullRow className="no-padding-top no-padding-right no-padding-bottom no-margin-bottom" 
              style={{paddingLeft:"150px"}}>
              <Checkbox iconStyle={{fill:"#47A1AB", marginRight:'10px'}} label={"PDF File"} labelStyle={{fontSize:'13px'}}
                        defaultChecked={false} ref="cbPDF" onCheck={(e, isInputChecked) => this.cbPDFChange(e, isInputChecked)} />         
            </FullRow>
            <FullRow className="no-padding-top no-padding-right no-padding-bottom" style={{paddingLeft:"150px"}}>
              <Checkbox iconStyle={{fill:"#47A1AB", marginRight:'10px'}} label={"CSV File"} labelStyle={{fontSize:'13px'}}
                        defaultChecked={true} ref="cbCSV" onCheck={(e, isInputChecked) => this.cbCSVChange(e, isInputChecked)} />         
            </FullRow>
            <FullRow className="no-padding no-margin-bottom mt-20 text-center">
              <button type="button" onClick={()=>this.setState({showDownloadDialog: false})} 
                className="btn btn-default btn-aa-info mr-20">Cancel</button>
              <button type="button" onClick={this.handleDownload.bind(this)} disabled={this.state.disabledBtnDownload}
                className="btn btn-default btn-aa-default">Download File</button>
            </FullRow>
          </Dialog>
			</div>
		)
	}

}

export default CampaignReport;


// WEBPACK FOOTER //
// ./src/components/Campaigns/Report/index.jsx